/* eslint-disable react/no-children-prop */
import { ArrowUpDownIcon, DownloadIcon, SearchIcon } from '@chakra-ui/icons';
import {
  Box,
  Button,
  HStack,
  Icon,
  Input,
  InputGroup,
  InputLeftElement,
  Select,
  Spinner,
  Stack,
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tooltip,
  Tr,
  useToast
} from '@chakra-ui/react';
import { MutableRefObject, useEffect, useRef, useState } from 'react';
import { CSVLink } from 'react-csv';
import { useParams } from 'react-router-dom';
import { useReactToPrint } from 'react-to-print';

import { EmailIcon } from '../../../assets/icons/EmailIcon';
import { FacebookIcon } from '../../../assets/icons/FacebookIcon';
import { LinkedinIcon } from '../../../assets/icons/LinkedinIcon';
import { LinkIcon } from '../../../assets/icons/LinkIcon';
import { QRCodeIcon } from '../../../assets/icons/QRCodeIcon';
import { TwitterIcon } from '../../../assets/icons/TwitterIcon';
import { WhatsAppIcon } from '../../../assets/icons/WhatsAppIcon';
import { exportExcel } from '../../../utils/excelexport';
import { PaginationRound } from '../pagination/PaginationRound';

type TableMidiaContentProps = {
  dataTable: {
    source: string;
    total: number;
  }[];
  setDataTable: any;
  newDataTable: any;
  setNewDataTable: any;
  quantitative: number;
  label: string;
  isLoading: boolean;
  dataOptionsForDataExport: {
    type: string;
  }[];
};

export const TableMidiaContent = ({
  dataTable,
  setDataTable,
  newDataTable,
  setNewDataTable,
  quantitative,
  label,
  isLoading,
  dataOptionsForDataExport
}: TableMidiaContentProps) => {
  const toast = useToast();

  const refPrint = useRef() as MutableRefObject<HTMLDivElement>;

  const [toggle, setToggle] = useState(false);

  const [dataExport, setDataExport] = useState('');
  const [valueForSearch, setValueForSearch] = useState('');

  const [currentPage, setCurrentPage] = useState(1);
  const [dataPerPage, setDataPerPage] = useState(10);

  const indexCurrentData = () => {
    return dataTable.slice(
      currentPage * dataPerPage - dataPerPage,
      currentPage * dataPerPage
    );
  };

  const borderDefault = '1px solid #9632FA';

  const csvData = () => {
    return dataTable.map((item) => {
      return { Origem: item.source, Acessos: item.total };
    });
  };

  const xlsxData = () => {
    return dataTable.map((item) => {
      let source = item.source;

      if (source === 'whatsapp') {
        source = 'WhatsApp';
      } else if (source === 'facebook') {
        source = 'Facbook';
      } else if (source === 'instagram') {
        source = 'Instagram';
      } else if (source === 'twitter') {
        source = 'Twitter';
      } else if (source === 'linkedin') {
        source = 'Linkedin';
      } else if (source === 'email') {
        source = 'E-Mail';
      } else if (source === 'qrcode') {
        source = 'QRCode';
      } else if (source == 'direct_url') {
        source = 'Link direto';
      }

      return { Origem: source, Acessos: item.total };
    });
  };

  const csvLink = () => {
    return {
      filename: `${label}.csv`,
      data: csvData()
    };
  };

  const handlePaginate = (pageNumber: number) => {
    setCurrentPage(pageNumber);
  };

  const handlePrint = useReactToPrint({
    content: () => {
      return refPrint.current;
    }
  });

  const handleLinkForExportData = () => {
    if (dataExport === '') {
      toast({
        position: 'top',
        description: `Selecione um tipo de arquivo`,
        status: 'error',
        duration: 10000,
        isClosable: true
      });
    }
    if (dataExport === 'pdf') {
      handlePrint();
    }

    if (dataExport === 'xlsx') {
      exportExcel({
        excelData: xlsxData(),
        fileName: `acessos-por-origem-${new Date()
          .toISOString()
          .substring(0, 10)}`
      });
    }
  };

  const handleFilterBySearch = () => {
    const valueForSearchOptions = dataTable.map((item) => item.source);
    const updateList = [...valueForSearchOptions];

    const listString = updateList.filter((item) => {
      return (
        item.toLocaleLowerCase().indexOf(valueForSearch.toLocaleLowerCase()) !==
        -1
      );
    });

    const listObject = dataTable.map((item) => {
      return listString?.includes(item.source) ? item : null;
    });

    const list = listObject.filter(Boolean);

    const verifList = list.map((item) => item?.source);

    if (verifList[0]) {
      setNewDataTable(dataTable);
    }
    if (list != undefined) {
      setNewDataTable(list);
    }
  };

  const handleSortingTable = () => {
    setToggle(!toggle);

    const sort = [...dataTable].sort((a, b) =>
      toggle ? a.total - b.total : b.total - a.total
    );
    setDataTable(sort);
  };

  useEffect(() => {
    handleFilterBySearch();
  }, [valueForSearch]);

  return (
    <>
      {' '}
      {isLoading ? (
        <Box
          w="100%"
          h="55vh"
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          gridGap="15px"
        >
          <Spinner
            thickness="6px"
            speed="0.65s"
            emptyColor="#FF5000"
            color="#FFFFFF"
            size="xl"
          />
          <Text>Carregando Acessos...</Text>
        </Box>
      ) : (
        <Stack
          m="30px 0 0 0 !important"
          bg="#FFFFFF"
          p="30px"
          justifyContent="space-between"
          borderRadius="24px"
          boxShadow="0px 0px 5px rgba(50, 50, 50, 0.25)"
        >
          <Box display="flex !important" justifyContent="space-between">
            <Stack>
              <Text fontWeight="700" fontSize="1.25rem" lineHeight="2rem">
                {label}
              </Text>
              <Text
                fontWeight="400"
                fontSize="1rem"
                lineHeight="1.5rem"
                color="#001E64"
              >
                Total de acessos: {quantitative}
              </Text>
            </Stack>
            <HStack gridGap="10px">
              <InputGroup w="250px">
                <InputLeftElement
                  pointerEvents="none"
                  h="50px"
                  children={<SearchIcon color="#001E64 " />}
                />
                <Input
                  w="250px"
                  h="50px"
                  value={valueForSearch}
                  border="1px solid #001E64 !important"
                  borderRadius="133px"
                  placeholder="Busca por (mídia)"
                  onChange={(e) => {
                    setValueForSearch(e.target.value);
                  }}
                  _hover={{}}
                  _active={{}}
                  _focus={{
                    '&:focus': {
                      boxShadow: 'none !important'
                    }
                  }}
                />
              </InputGroup>
              <Select
                w="250px"
                h="50px"
                value={dataExport}
                color={dataExport === '' ? '#828282' : '#001E64'}
                fontWeight={dataExport === '' ? '400' : '700'}
                border="1px solid #001E64 !important"
                borderRadius="133px"
                placeholder="Selecione um tipo de arquivo"
                onChange={(e) => {
                  setDataExport(e.target.value);
                }}
                _hover={{}}
                _active={{}}
                _focus={{
                  '&:focus': {
                    boxShadow: 'none !important'
                  }
                }}
              >
                {dataOptionsForDataExport.map((item, index) => {
                  return (
                    <option key={index} value={item.type}>
                      {item.type}
                    </option>
                  );
                })}
              </Select>
              {dataExport === 'csv' ? (
                <CSVLink {...csvLink()} separator={';'}>
                  <Tooltip
                    label="Exportar dados"
                    bg="gray.200"
                    placement="top-end"
                    color="#323232"
                  >
                    <DownloadIcon
                      m="0 !important"
                      w="18px"
                      h="18px"
                      color="#001E64"
                    />
                  </Tooltip>
                </CSVLink>
              ) : (
                <Box>
                  <Tooltip
                    label="Exportar dados"
                    bg="gray.200"
                    placement="top-end"
                    color="#323232"
                  >
                    <DownloadIcon
                      m="0 !important"
                      w="18px"
                      h="18px"
                      color="#001E64"
                      onClick={() => {
                        handleLinkForExportData();
                      }}
                    />
                  </Tooltip>
                </Box>
              )}
            </HStack>
          </Box>
          <TableContainer
            ref={refPrint}
            m="20px 0 0 0 !important"
            w="100%"
            maxH="160vh"
            overflowY="auto"
          >
            <Table
              variant="striped"
              colorScheme="whiteAlpha"
              size="sm"
              position="relative"
              style={{ borderCollapse: 'separate', borderSpacing: '0 10px' }}
            >
              <Thead
                h="3.25rem"
                z-index={9}
                position="sticky"
                top={0}
                zIndex={999}
                bg="#FFFFFF"
              >
                <Tr>
                  <Th
                    whiteSpace="normal"
                    textTransform="none"
                    fontSize="0.875rem"
                    fontWeight="700"
                    lineHeight="1.5rem"
                    color="#001E64"
                  >
                    Origem
                  </Th>
                  <Th
                    whiteSpace="normal"
                    textTransform="none"
                    fontSize="0.875rem"
                    fontWeight="700"
                    lineHeight="1.5rem"
                    color="#001E64"
                  >
                    Acessos
                    <ArrowUpDownIcon
                      m="0 0 0 5px !important"
                      onClick={() => {
                        handleSortingTable();
                      }}
                      fontSize="14px"
                      cursor="pointer"
                    />
                  </Th>
                </Tr>
              </Thead>
              <Tbody>
                {Array.isArray(indexCurrentData())
                  ? indexCurrentData().map((item, index) => {
                      if (newDataTable?.includes(item)) {
                        return (
                          <Tr key={index}>
                            <Td
                              display="flex"
                              alignItems="center"
                              gridGap="10px"
                              position="relative"
                              border="none"
                              bg="rgba(211, 222, 235, .5)"
                              fontSize="0.875rem"
                              lineHeight="1.5rem"
                              fontWeight="400"
                              borderRadius="4px 0 0 4px"
                            >
                              <Box
                                w="7px"
                                h="3.5rem"
                                bg={
                                  item.source === 'whatsapp'
                                    ? '#1BD741'
                                    : item.source === 'facebook'
                                    ? '#485A96'
                                    : item.source === 'linkedin'
                                    ? '#0A66C2'
                                    : item.source === 'instagram'
                                    ? ' #CC0786 '
                                    : item.source === 'twitter'
                                    ? '#1D9BF0'
                                    : '#9632FA'
                                }
                                borderRadius="24px 0 0 24px"
                                position="absolute"
                                left="0"
                              >
                                <span style={{ visibility: 'hidden' }}>
                                  tag
                                </span>
                              </Box>
                              <Box
                                bg={
                                  item.source === 'whatsapp'
                                    ? '#1BD741'
                                    : item.source === 'facebook'
                                    ? '#485A96'
                                    : item.source === 'linkedin'
                                    ? '#0A66C2'
                                    : item.source === 'instagram'
                                    ? ' #CC0786 '
                                    : item.source === 'twitter'
                                    ? '#1D9BF0'
                                    : '#FFFFFF'
                                }
                                borderRadius="50%"
                                w="14px"
                                h="14px"
                                p="20px"
                                display="flex"
                                justifyContent="center"
                                alignItems="center"
                                border={
                                  item.source === 'email' ||
                                  item.source === 'direct_url' ||
                                  item.source === 'qrcode'
                                    ? borderDefault
                                    : 'none'
                                }
                              >
                                <Icon
                                  fontSize="14px"
                                  as={
                                    item.source === 'whatsapp'
                                      ? WhatsAppIcon
                                      : item.source === 'email'
                                      ? EmailIcon
                                      : item.source === 'facebook'
                                      ? FacebookIcon
                                      : item.source === 'linkedin'
                                      ? LinkedinIcon
                                      : item.source === 'direct_url'
                                      ? LinkIcon
                                      : item.source === 'qrcode'
                                      ? QRCodeIcon
                                      : item.source === 'twitter'
                                      ? TwitterIcon
                                      : WhatsAppIcon
                                  }
                                />
                              </Box>
                              {item.source}
                            </Td>
                            <Td
                              border="none"
                              bg="rgba(211, 222, 235, .5)"
                              color="#001E64"
                              fontSize="0.875rem"
                              lineHeight="1.5rem"
                              fontWeight="400"
                            >
                              {item.total}
                            </Td>
                          </Tr>
                        );
                      }
                    })
                  : ''}
              </Tbody>
            </Table>
          </TableContainer>
          <PaginationRound
            currentPage={currentPage}
            dataPerPage={dataPerPage}
            setDataPerPage={setDataPerPage}
            dataTotal={dataTable.length}
            handlePaginate={handlePaginate}
          />
        </Stack>
      )}
    </>
  );
};
